<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

<div class="weeks" #container>
  <infl-calendar-horizontal-resources
    #resourcesComponent
    [resources]="resources()"
    [resourceTitle]="resourceTitle()"
    [heightTitle]="this.numberSection() ? 60 : 90"
    (changeDisplay)="onChangeDisplay()"
  />
  <div class="week-wrapper">
    <div class="week">
      <infl-calendar-view-week-horizontal
        #viewH1
        #viewH
        [resources]="resources()"
        [resourceTitle]="resourceTitle()"
        [days]="days()"
        [tasks]="tasks()"
        [day]="dayWeek1()"
        [start]="start()"
        [end]="end()"
        [numberSection]="numberSection()"
        [cellWidth]="cellWidth()"
        [canDrag]="canDrag()"
        [canSelect]="canSelect()"
        [enable]="enable()"
        [canResize]="canResize()"
        [dragByOutside]="dragByOutside()"
        [hourDivCount]="hourDivCount()"
        [sectionHeight]="sectionHeight()"
        [taskHeight]="taskHeight()"
        [showResources]="false"
        [onFortnight]="true"
        [draggingTask]="draggingTask()"
        [teleworks]="teleworks()"
        (taskUpdate)="taskUpdate.emit($event)"
        (taskCreation)="taskCreation.emit($event)"
        (taskHover)="taskHover.emit($event)"
        (taskClick)="taskClick.emit($event)"
        (taskDblClick)="taskDblClick.emit($event)"
        (taskContextMenu)="taskContextMenu.emit($event)"
        (periodSelection)="
          periodSelection.emit({ component: viewH1, selection: $event })
        "
        (hourPreselection)="hourPreselection.emit($event)"
        (clickOnSelection)="clickOnSelection.emit($event)"
        (dblClickOnSelection)="dblClickOnSelection.emit($event)"
        (resourcesInit)="onInitResources($event, 1)"
        (startDraggingTask)="draggingTask.set($event)"
        (dropOutside)="draggingTask.set(null)"
      >
      </infl-calendar-view-week-horizontal>
    </div>
    <div class="week">
      <infl-calendar-view-week-horizontal
        #viewH2
        #viewH
        [resources]="resources()"
        [resourceTitle]="resourceTitle()"
        [days]="days()"
        [tasks]="tasks()"
        [day]="dayWeek2()"
        [start]="start()"
        [end]="end()"
        [numberSection]="numberSection()"
        [cellWidth]="cellWidth()"
        [canDrag]="canDrag()"
        [canSelect]="canSelect()"
        [enable]="enable()"
        [canResize]="canResize()"
        [dragByOutside]="dragByOutside()"
        [hourDivCount]="hourDivCount()"
        [sectionHeight]="sectionHeight()"
        [taskHeight]="taskHeight()"
        [showResources]="false"
        [onFortnight]="true"
        [draggingTask]="draggingTask()"
        [teleworks]="teleworks()"
        (taskUpdate)="taskUpdate.emit($event)"
        (taskCreation)="taskCreation.emit($event)"
        (taskHover)="taskHover.emit($event)"
        (taskClick)="taskClick.emit($event)"
        (taskDblClick)="taskDblClick.emit($event)"
        (taskContextMenu)="taskContextMenu.emit($event)"
        (periodSelection)="
          periodSelection.emit({ component: viewH2, selection: $event })
        "
        (hourPreselection)="hourPreselection.emit($event)"
        (clickOnSelection)="clickOnSelection.emit($event)"
        (dblClickOnSelection)="dblClickOnSelection.emit($event)"
        (resourcesInit)="onInitResources($event, 2)"
        (startDraggingTask)="draggingTask.set($event)"
        (dropOutside)="draggingTask.set(null)"
      >
      </infl-calendar-view-week-horizontal>
    </div>
  </div>
</div>
